import { controlActions } from '../actions/controlActions';
import { getUserCredits } from './api';

let userCreditsRetries = 3;
export const userCreditsWithRetry = (dispatch: any) => {
  getUserCredits()
    .then(({ userCredit }) => {
      userCreditsRetries = 3;
      dispatch(controlActions.setUserCredits(userCredit));
    })
    .catch(() => {
      userCreditsRetries -= 1;
      if (userCreditsRetries > 0) {
        setTimeout(() => {
          userCreditsWithRetry(dispatch);
        }, 1000);
      }
    });
};
